import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import Splide from "@splidejs/splide";
import { RevealFade } from "../fx/Common";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.slideshow = this.element.querySelector(".jsSlideshow");
    this.DOM.landmark = this.DOM.view.querySelector(".jsLandmark");
    //! Options
    this.options = JSON.parse(this.element.getAttribute("data-options"));
    this.options.perPage =
      typeof this.options.perPage != "undefined" ? this.options.perPage : 2;
    this.options.fixedWidth =
      typeof this.options.fixedWidth != "undefined"
        ? this.options.fixedWidth
        : "50%";
    //! Fns
    gsap.delayedCall(Env.timingDelayFx / 1000, () => {
      RevealFade(this.DOM.view);
      this.makeSlideshow();
    });
    this.funcResize = this.resize.bind(this);
    Channels.on("window::smartresize", this.funcResize);
  }

  makeSlideshow() {
    this.slideshow = new Splide(this.DOM.slideshow, {
      arrows: false,
      gap: 48,
      interval: 7000,
      padding: {
        left: this.DOM.landmark.getBoundingClientRect().x,
        right: this.DOM.landmark.getBoundingClientRect().x,
      },
      pauseOnFocus: false,
      pauseOnHover: false,
      pagination: false,
      heightRatio: 0.4,
      fixedWidth: this.options.fixedWidth,
      perPage: this.options.perPage,
      perMove: 1,
      rewind: true,
      rewindByDrag: true,
      speed: 700,
      type: "slide",
      omitEnd: true,
      breakpoints: {
        640: {
          arrows: false,
          pagination: true,
          heightRatio: 1.3,
          fixedWidth: "80%",
          gap: 20,
          padding: { left: 32, right: 32 },
          perPage: 1,
        },
      },
      classes: {
        pagination: "splide__pagination !tw-mx-ui-x-mobile !tw-mt-[30px]",
        page: "splide__pagination__page tw-h-[1px] tw-w-full",
      },
    });

    this.ref.btnPrev[0].addEventListener("click", () => {
      this.slideshow.go("-");
    });

    this.ref.btnNext[0].addEventListener("click", () => {
      this.slideshow.go("+");
    });

    this.slideshow.mount();
  }

  resize() {
    this.slideshow.destroy();
    this.makeSlideshow();
  }

  unmount() {
    if (typeof this.cursor != "undefined") {
      this.cursor.destroy();
    }

    this.slideshow.destroy(true);
    Channels.removeListener("window::smartresize", this.funcResize);
  }
}
